var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShevronRight = function SvgShevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    fill: "none",
    viewBox: "0 0 8 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.55 6.73a.4.4 0 0 0 0-.6L2.42.93c-.18-.17-.46-.17-.6 0l-.7.7c-.18.14-.18.43 0 .6l4.14 4.19-4.14 4.21a.4.4 0 0 0 0 .6l.7.7c.14.18.42.18.6 0z"
  })));
};
export default SvgShevronRight;